import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-label"];
import { IconButton } from '../IconButton';
import { Flex } from '../../../components/Flex/Flex';
import I18n from 'I18n';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const NextButton = _ref => {
  let {
      'aria-label': ariaLabel = I18n.text('salesUI.UINextButton.label')
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(IconButton, Object.assign({}, rest, {
    "aria-label": ariaLabel,
    "data-button-type": "navigation",
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      as: "span",
      children: /*#__PURE__*/_jsx(RightIcon, {})
    })
  }));
};